export const initialBodyValue = {
    articleId: null,
    tripId: null,
    fields : [],
    attachments: []
}
export const DELETE_ACCOUNT_ARTICLE_ID = 18443816997913;
export const LOST_ITEM_ARTICLE_ID = 900003102263;
export const MAX_ATTACHMENTS = 3;
export const PER_PAGE = 20;
export const EXCLUDED_IMG = 'www.rydesharing.com/wp-content/uploads/banner_smaller-1.png';